"use client";

import { Menu } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden md:flex gap-6">
        <div className="h-5 w-20 bg-muted animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className="h-auto p-0 hover:bg-transparent data-[active=true]:bg-transparent focus:bg-transparent data-[active=true]:focus:bg-transparent data-[active=true]:hover:bg-transparent">
              <Link to={item.href || "#"} id={item.href === "/EspaceProPage" ? "inscription-pro" : undefined} className="text-foreground text-sm font-medium transition-all hover:text-primary-dark relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all hover:after:w-full focus-ring">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuDropdown() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isOpen, setIsOpen] = useState(false);
  if (loading) {
    return <Button variant="ghost" size="icon" className="md:hidden" disabled aria-label="Chargement du menu">
        <Menu className="size-5 text-foreground" />
      </Button>;
  }
  return <div className="md:hidden relative">
      <Button variant="ghost" size="icon" onClick={() => setIsOpen(!isOpen)} className="hover:bg-accent hover:text-accent-foreground transition-all" aria-label="Menu des catégories" aria-expanded={isOpen}>
        <Menu className="size-5 text-foreground" />
      </Button>

      {isOpen && <>
          <div className="fixed inset-0 z-40 bg-dark-background/60 backdrop-blur-sm" onClick={() => setIsOpen(false)} aria-hidden="true" />
          <div className="absolute top-full right-0 mt-2 w-64 bg-background border border-border rounded-lg shadow-strong z-50 overflow-hidden">
            <nav className="py-2">
              {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} id={item.href === "/EspaceProPage" ? "inscription-pro" : undefined} data-index={i} className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-accent hover:text-accent-foreground transition-all focus-ring" onClick={() => setIsOpen(false)}>
                  {item.label}
                </Link>)}
            </nav>
          </div>
        </>}
    </div>;
}
export default function EnTete() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 50);
    return () => clearTimeout(timer);
  }, []);
  return <header className="bg-background border-b border-border fixed top-0 left-0 right-0 z-50 transition-transform duration-500 ease-out" style={{
    transform: isVisible ? "translateY(0)" : "translateY(-20px)"
  }}>
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center focus-ring rounded-full">
          <div className="flex items-center gap-2 px-5 py-3 transition-all hover:scale-105">
            <svg className="h-10" viewBox="0 0 180 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Be Travaux">
              <path d="M20 10 Q90 4, 160 10" stroke="#f59e0b" strokeWidth="3" strokeLinecap="round" fill="none" />
              
              <text x="20" y="34" fontFamily="ui-sans-serif, system-ui, -apple-system" fontSize="22" fontWeight="600" fill="#f59e0b" letterSpacing="-0.5">
                Be
              </text>
              
              <text x="48" y="34" fontFamily="ui-sans-serif, system-ui, -apple-system" fontSize="22" fontWeight="600" fill="#f59e0b" letterSpacing="-0.5">
                Travaux
              </text>
            </svg>
          </div>
        </Link>

        <div className="hidden md:block">
          <MenuProvider menu_id="3">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        <MenuProvider menu_id="3" className="md:hidden">
          <MobileMenuDropdown />
        </MenuProvider>
      </div>
    </header>;
}